import { FormControl, MenuItem, Select, makeStyles } from '@material-ui/core';

type Props = {
    value: string;
    setValue: React.ChangeEventHandler<HTMLSelectElement>;
    options: any;
};

const SGSCardTitle: React.FC<Props> = ({ value, setValue, options }) => {
    //const [menuOpen, setMenuOpen] = useState(false);
    const classes = useStyles();

    return (
        <FormControl className={classes.formControl} fullWidth>
            <Select
                labelId="selector-label"
                id="selector"
                value={value}
                label="Select an option"
                onChange={setValue}
                inputProps={{
                    className: classes.input,
                }}
                MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                }}
            >
                {options.map((o) => (
                    <MenuItem key={o.value} value={o.value} className="text-uppercase">
                        {o.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SGSCardTitle;

const useStyles = makeStyles(() => ({
    formControl: {
        minWidth: 120,
        paddingRight: '30px',
        '& .MuiInputBase-input': {
            backgroundColor: 'transparent', // Set the background color always to red
            color: 'white', // Set the text color to white
        },
        '& .MuiInput-underline:after': {
            borderBottom: 'none',
        },
        '& .MuiInput-underline:before': {
            borderBottom: 'none',
        },
        '&:hover .MuiInput-underline:after': {
            borderBottom: 'none', // Remove the underline on hover
        },
        '&:hover .MuiInput-underline:before': {
            borderBottom: 'none', // Remove the underline on hover
        },
        '& .MuiSvgIcon-root.MuiSelect-icon': {
            color: 'white', // Set the color of the MuiSvgIcon-root within MuiSelect-icon to white
            width: '40px',
            height: '40px',
            top: -11,
            margin: 0,
            padding: 0,
        },
    },
    input: {
        color: '#FFF',
        fontFamily: 'Open Sans ',
        padding: 0,
    },
}));
